<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.0313 3C18.1344 3 18.2188 3.08437 18.2188 3.1875V5.71875H20.75C20.8531 5.71875 20.9375 5.80312 20.9375 5.90625V7.03125C20.9375 7.13438 20.8531 7.21875 20.75 7.21875H18.2188V9.75C18.2188 9.85313 18.1344 9.9375 18.0313 9.9375H16.9063C16.8031 9.9375 16.7188 9.85313 16.7188 9.75V7.21875H14.1875C14.0844 7.21875 14 7.13438 14 7.03125V5.90625C14 5.80312 14.0844 5.71875 14.1875 5.71875H16.7188V3.1875C16.7188 3.08437 16.8031 3 16.9063 3H18.0313Z" fill="#2D3843"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.89445 11.5528C10.1414 12.0468 9.94121 12.6474 9.44724 12.8944L4.76476 15.2357L14.3549 17.9209L21.4855 13.6425C21.9591 13.3584 22.5734 13.5119 22.8575 13.9855C23.1417 14.4591 22.9881 15.0733 22.5145 15.3575L15.0145 19.8575C14.7788 19.9989 14.4952 20.0371 14.2304 19.963L1.73039 16.463C1.33235 16.3515 1.0439 16.0066 1.00456 15.5952C0.96522 15.1837 1.1831 14.7904 1.55281 14.6056L8.55281 11.1056C9.04679 10.8586 9.64746 11.0588 9.89445 11.5528Z" fill="#2D3843"/>
  </svg>
</template>

<script>
export default {
  name: 'SVGBar',
};
</script>

<style scoped lang="scss">

</style>
